import React, { PropsWithChildren } from "react";
import { Icon } from "../../Icon/Icon";
import styles from "./HilightedBadge.module.scss";

export const HilightedBadge: React.FC<PropsWithChildren<unknown>> = ({
  children
}) => {
  return (
    <div className={styles.container}>
      <Icon name="star" padding={false} className={styles.icon} /> {children}
    </div>
  );
};
